import {
    FaRadiation, FaShieldHalved, FaUserShield, FaCrosshairs,
    FaFaceSmile,
    FaUserDoctor,
    FaStethoscope,
    FaTrophy, FaCubes, FaChartLine, FaWallet,
} from "react-icons/fa6";


export const featuresCardData = [
    {
        icon: <FaRadiation />,
        title: "Low Radiation Imaging",
        description:
            "Our Mini C-Arms use less radiation while maintaining image quality. Providers can adjust dosage settings for accurate imaging and reduce patient radiation risks.",
    },
    {
        icon: <FaShieldHalved />,
        title: "Routine Safety & Maintenance",
        description:
            "Routine maintenance prevents malfunctions that could cause unintended exposure. Quality assurance programs ensure machines meet safety standards.",
    },
    {
        icon: <FaUserShield />,
        title: "Safe Clinical Operation",
        description:
            "By following strict safety protocols and reducing radiation, providers can fully use Mini C-Arms. They will then gain all their benefits. This will protect both patients and professionals.",
    },
];

export const benefitsData = [
    {
        title: "Precision for Small Areas",
        description:
            "Capture precise images of hands, knees, joints, and other small areas.",
        icon: FaCrosshairs,
    },

    {
        title: "Enhanced Patient Comfort",
        description:
            "Provide comfortable imaging with a compact, less intimidating design.",
        icon: FaFaceSmile,
    },

    {
        title: "Ideal for Specialized Practices",
        description:
            "Support precise imaging for orthopedic, podiatry, and sports medicine practices.",
        icon: FaUserDoctor,
    },

    {
        title: "Efficient Clinical Imaging",
        description:
            "Improve workflow with fast, flexible imaging for specialized procedures.",
        icon: FaStethoscope,
    },
];

export const stepper = [
    {
        icon: <FaTrophy />,
        title: "Unmatched Results",
        description:
            "Achieve precise imaging for targeted treatments and better clinical outcomes.",
        align: "bottom",
    },
    {
        icon: <FaCubes />,
        title: "Flexible Designs",
        description:
            "Use compact Mini C-Arms designed for flexible clinical imaging.",
        align: "top",
    },
    {
        icon: <FaChartLine />,
        title: "Reimbursement Rates",
        description:
            "Maximize reimbursement potential with efficient Mini C-Arm procedures.",
        align: "bottom",
        featured: true,
    },
    {
        icon: <FaWallet />,
        title: "No Upfront Costs",
        description:
            "Access advanced Mini C-Arm imaging without high upfront equipment costs.",
        align: "top",
    },
];